module.exports = __webpack_public_path__ + "img/yt-pe.e3142171.png";